// Brand logos data
const brandLogos = [
  { name: 'Samsung', src: '/images/brand-logos/samsung.png' },
  { name: 'Apple', src: '/images/brand-logos/apple.png' },
  { name: 'Coca-Cola', src: '/images/brand-logos/coca-cola.png' },
  { name: 'Chanel', src: '/images/brand-logos/chanel.png' },
  { name: 'Amazon', src: '/images/brand-logos/amazon.png' },
  { name: 'Nike', src: '/images/brand-logos/nike.png' },
  { name: "McDonald's", src: '/images/brand-logos/mcdonalds.png' },
  { name: 'Sony', src: '/images/brand-logos/sony.png' },
  { name: 'Louis Vuitton', src: '/images/brand-logos/louis-vuitton.png' },
  { name: 'Disney', src: '/images/brand-logos/disney.png' },
];

export const StaticBrandLogos = () => {
  return (
    <div className="my-6 flex flex-col gap-1 py-4">
      <div className="flex justify-center">
        <div className="grid grid-cols-5 gap-2">
          {brandLogos.map((logo) => (
            <div
              key={logo.name}
              className="flex size-16 items-center justify-center p-2"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="size-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Powered by Brandfetch */}
      <div className="flex flex-col items-center gap-1">
        <p className="font-normal text-root-size-body-sm text-neutral-600">
          Powered by
        </p>
        <img
          src="/images/brand-logos/brandfetch.png"
          alt="Brandfetch logo"
          className="size-12 h-4 object-contain"
        />
      </div>
    </div>
  );
};
